import BaseModal from '../base-modal/base-modal';

import './developers-contact-modal.scss';

export default class DevelopersContactModal extends BaseModal {}
